import { AccountNavigationView } from '@playbooks/components/account/account-navigation-view';
import { useTheme } from '@playbooks/contexts';

const AccountDropAppearance = ({ onPrev }) => {
	const theme = useTheme();
	const options = [
		{ icon: 'sun-bright', label: 'Light', value: 'light' },
		{ icon: 'moon', label: 'Dark', value: 'dark' },
		{ icon: 'desktop', label: 'System', value: 'system' },
	] as const;
	return (
		<AccountNavigationView
			title='Appearance'
			onBack={onPrev}
			items={options.map(option => ({
				icon: option.icon,
				label: option.label,
				selected: theme.loaded && theme.preference === option.value,
				onClick: () => theme.setPreference(option.value),
			}))}
		/>
	);
};
export { AccountDropAppearance };
